var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:[
    _vm.type,
    _vm.size,
    _vm.disabled ? 'disabled' : '',
    _vm.loading ? 'loading' : '',
    _vm.icon ? 'icon' : '',
    _vm.fullwidth ? 'fullwidth' : '',
    _vm.flat ? 'flat' : '',
    _vm.tooltipOnDisabled && _vm.disabled ? 'disabled-tooltip' : ''
  ],style:({ color: _vm.color }),attrs:{"disabled":_vm.disabled || _vm.loading ? true : false,"type":_vm.submit ? 'submit' : 'button',"title":_vm.title},on:{"click":_vm.handleClick,"focus":_vm.handleFocus,"blur":_vm.handleBlur}},[(_vm.icon)?_c('i',{class:'icon-' + _vm.icon}):_vm._e(),(!_vm.icon)?_vm._t("default"):_vm._e(),(_vm.loading)?_c('span',{staticClass:"loading-wrapper"},[_c('i',{staticClass:"icon-loading animate-spin"})]):_vm._e(),(_vm.tooltipOnDisabled)?_c('span',{staticClass:"tooltip-on-disabled animated fadeIn",style:([
      _vm.tooltipOnDisabledFixed === 'right'
        ? { right: '0', left: 'auto', transform: 'none' }
        : {}
    ])},[_vm._v(" "+_vm._s(_vm.tooltipOnDisabled)+" ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }